/*
 * Search.js
 * ---------
 * Provides search box enhancements to power up the floating search panels.
 *
 * @author    Ian J Robotham <i.robotham@abdn.ac.uk>
 * @version
 * @copyright
 */
var insearch = false;

$('document').ready(function () {
    // Power up the search button
    $('#searchactionbtn').bind('click', function (e) {
        // Grab the contents of the search box
        var searchterm = $('#searchterm').val();

        // Check the action to perform
        if (!insearch) {
            // Tell the search form we are actively searching
            $('#searchform').toggleClass('insearch');

            // Not currently searching, so show the search box
            $('#searchterm').toggleClass('hidden');
            // Also show/hide any HTML5 Shiv for IE
            $('#searchform .placeholder').toggleClass('hidden');

            // Show the search results panel
            $('#searchpanel').toggleClass('hide');

            // Give focus to search box
            $('#searchterm').focus();

            insearch = true;
        } else if (insearch && searchterm.length > 0) {
            // Clear the results
            $('#searchresults').html('');

            // We have some text, so the button acts as a clear button
            $('#searchterm').val('');

            // Give focus to search box
            $('#searchterm').focus();

            // Change the icons
            toggleSearchActionButtonIcons();
        } else {
            // Hide the search box
            $('#searchterm').toggleClass('hidden');
            // Also show/hide any HTML5 Shiv for IE
            $('#searchform .placeholder').toggleClass('hidden');

            // Show the search results panel
            $('#searchpanel').toggleClass('hide');

            // Tell the search form we have stopped searching
            $('#searchform').toggleClass('insearch');

            // We are no longer in search mode
            insearch = false;
        }

        e.preventDefault();
        return false;
    });

    // Power up the keyboard listener
    $('#searchterm').bind('keyup', function () {
        var searchterm = $('#searchterm').val();

        if (searchterm.length > 0) {
            toggleSearchActionButtonIcons('searching');
        } else {
            toggleSearchActionButtonIcons('waiting');
        }

        // If we have at least 3 character, do a search
        if (searchterm.length >= 3) {
            searchHandler(searchterm);
        }
    });
});

function toggleSearchActionButtonIcons(state) {
    if (state == 'searching') {
        // A search term exists
        $('#searchactionicon').removeClass('icon-search');
        $('#searchactionicon').addClass('icon-remove-sign');
    } else {
        // Waiting for a search term
        $('#searchactionicon').addClass('icon-search');
        $('#searchactionicon').removeClass('icon-remove-sign');
    }
    // Set the icons
}

/**
 *
 * @param {type} term
 * @returns {undefined}
 */
function searchHandler(term) {
    // $('#searchresults').html('No results for '+term);
    var url = 'search/ajaxhandler/' + encodeURIComponent(term);
    $('#searchresults').load(url);
}
